import { orderStatus as OrderStatus } from '@/constants';
import dateFormatType from '@/constants/dateFormatType';
import { formatDate } from '@/utils';
export default class OrderHistory {
    _statusCode = null;
    _createdAt;
    _updateMemo;
    _workerDTO;
    _userDTO;
    _assignGroupPhone;
    _assignGroupName;
    _allocatedWorkerName;
    constructor({ statusCode, createdAt, updateMemo, workerDTO, userDTO, assignGroupPhone, assignGroupName, allocatedWorkerName, }) {
        this._statusCode = statusCode;
        this._createdAt = createdAt;
        this._updateMemo = updateMemo;
        this._workerDTO = workerDTO;
        this._userDTO = userDTO;
        this._assignGroupPhone = assignGroupPhone;
        this._assignGroupName = assignGroupName;
        this._allocatedWorkerName = allocatedWorkerName;
    }
    get status() {
        // 배달리스트에서는 기존로직대로 노출, 상세이력에서만 '배달요청'으로 출력
        if (this._statusCode === OrderStatus.WORKER_REQUESTED.code) {
            return OrderStatus[OrderStatus.WORKER_REQUESTED.code]?.valueForTimeline;
        }
        return OrderStatus[this._statusCode]?.value;
    }
    get createdAt() {
        return formatDate(this._createdAt, dateFormatType.FULL_DATE);
    }
    get updateMemo() {
        return this._updateMemo;
    }
    get name() {
        return this._workerDTO?.name ?? this._userDTO?.name;
    }
    get id() {
        return this._workerDTO?.code ?? this._userDTO?.userId;
    }
    get tel() {
        return this._assignGroupPhone;
    }
    get agency() {
        return this._assignGroupName;
    }
    get allocatedWorkerName() {
        return this._allocatedWorkerName;
    }
}
